import { notification } from "antd";
import i18next from "i18next";

export const logoutUser = (
  message = i18next.t("header.logoutSuccessTitle"),
  description = i18next.t("header.logoutSuccessMessage")
) => {
  localStorage.removeItem("token");
  localStorage.removeItem("userId");
  localStorage.removeItem("userAddPropertyData");
  notification.success({
    message,
    description,
    placement: "topRight"
  });
};

export default logoutUser;
